<template>
  <div @click="openDialog">
    <div>
      账号换绑
    </div>
    <a-modal
      title="账号换绑"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确定"
      :key="flag"
      @ok="handleOk"
      :visible="visible">
      <a-form>
        <a-form-item label="换绑类型" :label-col="{ span: 8 }">
          <a-select defaultValue="phone" style="width: 120px" @change="handleChangeType">
            <a-select-option value="phone">换手机号</a-select-option>
            <a-select-option value="wx">换微信</a-select-option>
            <a-select-option value="both">都换</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="旧手机号" :label-col="{ span: 8 }">
          <a-input :defaultValue="oldPhone" disabled style="width: 150px"></a-input>
        </a-form-item>
        <a-form-item label="新手机号" :label-col="{ span: 8 }">
          <a-input v-model="newPhone" placeholder="请输入新手机号码" style="width: 150px"></a-input>
        </a-form-item>
        <a-form-item>
          <a-checkbox @change="onChange" style="margin-left: 156px;">强制换绑</a-checkbox>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ChangeTel',
  props: {
    oldPhone: Number
  },
  data () {
    return {
      changePhoneUrl: global.DOMAIN + 'uclient/change_phone_or_wx',
      newPhone: undefined,
      changeType: 'phone',
      force: 0,
      visible: false,
      flag: 1
    }
  },
  methods: {
    openDialog () {
      this.visible = true
      this.flag++
    },
    handleChangeType (value) {
      this.changeType = value
    },
    onChange (e) {
      this.force = e.target.checked ? 1 : 0
    },
    handleOk () {
      if (!this.newPhone) {
        this.$message.error('新手机号为空')
        return
      }
      this.axios.post(this.changePhoneUrl, {
        token: sessionStorage.token,
        old_phone: String(this.oldPhone),
        new_phone: this.newPhone,
        change_type: this.changeType,
        force: this.force
      }).then(res => {
        if (res.data.err_code === 0) {
          this.$message.success('换绑成功')
          this.visible = false
          this.newPhone = undefined
          this.changeType = 'phone'
          this.force = 0
        } else {
          this.$message.error(res.data.content.des)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    handleCancel () {
      this.visible = false
      this.newPhone = undefined
      this.changeType = 'phone'
      this.force = 0
    }
  }
}
</script>
